module.exports = __webpack_public_path__ + "./assets/fonts/OpenSans-SemiBold.ttf?ba5cde21eeea0d57ab7efefc99596cce";